<template>
  <div>
    <div class="card mb-4" v-if="personalInfo">
      <div class="card-body p-4 p-md-5">
        <h5 class="text-highlighted">Osobné údaje</h5>
        <div class="row">
          <div class="col-12 col-md-6">
            <div v-if="personalInfo.person_type_id === 1">
              <div class="my-1"><b>Vaše osobné údaje</b></div>
              <div
                v-for="(item, i) in infoFields.personal"
                :key="i"
              >
                <span>{{ item.label }}:</span>
                <span
                  v-if="item.type === 'date'"
                  class="color-medium-gray ml-3"
                  >{{ personalInfo[i] | date }}</span
                >
                <span v-else class="color-medium-gray ml-3">{{
                  personalInfo[i]
                }}</span>
              </div>
            </div>
            <div v-if="personalInfo.person_type_id === 2">
              <div class="my-1"><b>Údaje o spoločnosti</b></div>
              <div
                v-for="(item, i) in infoFields.company"
                :key="i"
              >
                <span>{{ item.label }}:</span
                ><span class="color-medium-gray ml-3">{{
                  personalInfo[i]
                }}</span>
              </div>
            </div>
            <div v-if="personalInfo.person_type_id === 3">
              <div class="my-1"><b>Údaje o dieťati</b></div>
              <div
                v-for="(item, i) in infoFields.child"
                :key="i"
              >
                <span>{{ item.label }}:</span
                ><span class="color-medium-gray ml-3">{{
                  personalInfo[i]
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mt-2 mb-1"><b>Adresa</b></div>
            <div
              v-for="(item, i) in infoFields.address"
              :key="i"
            >
              <span>{{ item.label }}:</span
              ><span class="color-medium-gray ml-3">{{ personalInfo[i] }}</span>
            </div>
            <div class="mt-4 mb-1"><b>Bankové spojenie</b></div>
            <div
              v-for="(item, i) in infoFields.bankAccount"
              :key="i"
            >
              <span>{{ item.label }}: </span>
              <span v-if="personalInfo[i]" class="color-medium-gray ml-3">{{
                i === "currency" ? personalInfo[i].name : personalInfo[i]
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-1">
      <div class="card-body p-4 p-md-5">
        <h3 class="text-highlighted">Investičný dotazník</h3>
        <div
          class="mt-3"
          v-for="(question, i) in investmentQuestionnaire"
          :key="i"
        >
          <span class="">{{ question.question }}</span
          ><br />
          <span class="color-medium-gray">{{ question.answer }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import questionnaireQuestions from "../components/InvestmentQuestionnaireQuestions";

export default {
  name: "onboardingSummary",
  mounted() {
    this.$emit("can-continue", { value: true });
    this.$store.dispatch("onboarding/getPersonalInfo");
    this.$store.dispatch("onboarding/getInvestmentQuestionnaire");
  },
  computed: {
    model() {
      return questionnaireQuestions;
    },
    personalInfo() {
      return this.$store.state.onboarding.personalInfo;
    },
    investmentQuestionnaire() {
      return this.$store.state.onboarding.investmentQuestionnaire;
    }
  },
  data() {
    return {
      infoFields: {
        personal: {
          email: {
            label: "Email",
            type: "string"
          },
          phone: {
            label: "Telefónne číslo",
            type: "string"
          },
          academic_title_before: {
            label: "Titul",
            type: "string"
          },
          name: {
            label: "Meno",
            type: "string"
          },
          surname: {
            label: "Priezvisko",
            type: "string"
          },
          academic_title_after: {
            label: "Titul za menom",
            type: "string"
          },
          birthdate: {
            label: "Dátum narodenia",
            type: "date"
          },
          birthnumber: {
            label: "Rodné číslo",
            type: "string"
          },
          nationality2: {
            label: "Štátna príslušnosť",
            type: "string"
          },
          idcard_no: {
            label: "Číslo preukazu totožnosti (OP/pas)",
            type: "string"
          },
          idcard_validity: {
            label: "Platnosť preukazu totožnosti",
            type: "date"
          }
        },
        company: {
          email: {
            label: "Email",
            type: "string"
          },
          phone: {
            label: "Telefónne číslo",
            type: "string"
          },
          company_name: {
            label: "Názov spoločnosti",
            type: "string"
          },
          company_idno: {
            label: "IČO",
            type: "string"
          },
          company_vat: {
            label: "DIČ",
            type: "string"
          }
        },
        child: {
          email: {
            label: "Email",
            type: "string"
          },
          phone: {
            label: "Telefónne číslo",
            type: "string"
          },
          academic_title_before: {
            label: "Titul",
            type: "string"
          },
          name: {
            label: "Meno",
            type: "string"
          },
          surname: {
            label: "Priezvisko",
            type: "string"
          },
          academic_title_after: {
            label: "Titul za menom",
            type: "string"
          },
          birthdate: {
            label: "Dátum narodenia",
            type: "string"
          },
          birthnumber: {
            label: "Rodné číslo",
            type: "string"
          },
          nationality: {
            label: "Štátna príslušnosť",
            type: "string"
          },
          idcard_no: {
            label: "Číslo preukazu totožnosti (OP/pas)",
            type: "string"
          }
        },
        address: {
          street: {
            label: "Ulica",
            type: "string"
          },
          city: {
            label: "Mesto",
            type: "string"
          },
          zip: {
            label: "PSČ",
            type: "string"
          }
        },
        bankAccount: {
          bank_account_owner_name: {
            label: "Názov účtu",
            type: "string"
          },
          iban: {
            label: "IBAN",
            type: "string"
          },
          swift: {
            label: "SWIFT kód",
            type: "string"
          },
          currency: {
            label: "Mena účtu",
            type: "string"
          }
        }
      }
    };
  },
  methods: {
    submit() {
      this.confirm();
    },
    confirm() {
      this.$parent.loading = true;
      this.$store
        .dispatch("onboarding/confirmSummary")
        .then(() => {
          this.$parent.loading = false;
          this.$parent.nextStep();
        })
        .catch(() => {
          this.$parent.loading = false;
        });
    }
  }
};
</script>
